import InnovatioWrapper from "../../../components/Innovation/InnovationWrapper";

const About: React.FC = () => {
  return <InnovatioWrapper />;
};

export default About;
